var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectedBadge1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 24,
    viewBox: "0 0 54 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 24,
    rx: 12,
    fill: "#D85140",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5002 18.3333C25.5779 18.3333 24.7113 18.1583 23.9002 17.8083C23.0891 17.4583 22.3835 16.9833 21.7835 16.3833C21.1835 15.7833 20.7085 15.0778 20.3585 14.2667C20.0085 13.4556 19.8335 12.5889 19.8335 11.6667C19.8335 10.7444 20.0085 9.87778 20.3585 9.06667C20.7085 8.25556 21.1835 7.55 21.7835 6.95C22.3835 6.35 23.0891 5.875 23.9002 5.525C24.7113 5.175 25.5779 5 26.5002 5C27.4224 5 28.2891 5.175 29.1002 5.525C29.9113 5.875 30.6168 6.35 31.2168 6.95C31.8168 7.55 32.2918 8.25556 32.6418 9.06667C32.9918 9.87778 33.1668 10.7444 33.1668 11.6667C33.1668 12.5889 32.9918 13.4556 32.6418 14.2667C32.2918 15.0778 31.8168 15.7833 31.2168 16.3833C30.6168 16.9833 29.9113 17.4583 29.1002 17.8083C28.2891 18.1583 27.4224 18.3333 26.5002 18.3333ZM26.5002 17C27.1002 17 27.6779 16.9028 28.2335 16.7083C28.7891 16.5139 29.3002 16.2333 29.7668 15.8667L22.3002 8.4C21.9335 8.86667 21.6529 9.37778 21.4585 9.93333C21.2641 10.4889 21.1668 11.0667 21.1668 11.6667C21.1668 13.1556 21.6835 14.4167 22.7168 15.45C23.7502 16.4833 25.0113 17 26.5002 17ZM30.7002 14.9333C31.0668 14.4667 31.3474 13.9556 31.5418 13.4C31.7363 12.8444 31.8335 12.2667 31.8335 11.6667C31.8335 10.1778 31.3168 8.91667 30.2835 7.88333C29.2502 6.85 27.9891 6.33333 26.5002 6.33333C25.9002 6.33333 25.3224 6.43056 24.7668 6.625C24.2113 6.81944 23.7002 7.1 23.2335 7.46667L30.7002 14.9333Z",
    fill: "#D85140"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedBadge1);
export default __webpack_public_path__ + "static/media/rejectedBadge_1.72f2b01b9081c555db8bd06310e8f1b0.svg";
export { ForwardRef as ReactComponent };